import { render, staticRenderFns } from "./DCard.vue?vue&type=template&id=4cd453ce&scoped=true&"
import script from "./DCard.vue?vue&type=script&lang=js&"
export * from "./DCard.vue?vue&type=script&lang=js&"
import style0 from "./DCard.vue?vue&type=style&index=0&id=4cd453ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd453ce",
  null
  
)

export default component.exports